import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component that sends space/branch data to native app
// and receives branch selection changes back
export default class extends BridgeComponent {
  static component = "navbar"

  static values = {
    spaceGroup: String,
    spaceBranch: String,
    availableSpaces: Array,
    userName: String,
    // Sales reps get a fixed branch context — the native navbar hides the
    // space/branch dropdown when this is false.
    selectorEnabled: { type: Boolean, default: true },
    // When present, the native navbar renders a back-arrow + title row
    // instead of the space/branch picker — set from the page's own
    // back_path/title (see shared/_mobile_shell.html.erb) so a pushed/detail
    // page's back-nav lives in NATIVE chrome, which a WebView-rendered flash
    // toast can never cover (unlike the in-page sticky header it replaces).
    navBackPath: { type: String, default: "" },
    navTitle: { type: String, default: "" },
    // Primary page actions (Edit, Add task, …) rendered as trailing text
    // buttons in the native top bar. Each entry is
    // `{ label, path, testid? }`; tapping one visits `path` in the current
    // tab's WebView. Empty on pages that declare none. Declared server-side
    // via `add_mobile_nav_action` (MobileNavActionsHelper).
    navActions: Array,
    // CONEK-5597 — per-tenant navbar background, as a 6-char hex string
    // ("#RRGGBB"). Empty when the tenant has no brand override, so the
    // native side falls back to its own teal default. Comes from
    // `SpaceGroup::Brand#to_bridge_payload[:navbarBackground]` via a
    // `data-bridge--navbar-navbar-background-value="…"` attribute on
    // the wrapper div in `mobile.html.erb`.
    navbarBackground: { type: String, default: "" },
  }

  connect() {
    super.connect()
    // Send space data; the library queues this if the bridge isn't ready yet.
    // The reply callback is unreliable when the native ComposeView lives outside
    // the fragment view hierarchy — NavbarComponent.kt bypasses replyTo and
    // drives navigation via evaluateJavascript directly.
    this.send(
      "connect",
      {
        currentSpaceGroup: this.spaceGroupValue,
        currentSpaceBranch: this.spaceBranchValue,
        availableSpaces: this.availableSpacesValue,
        userName: this.userNameValue,
        selectorEnabled: this.selectorEnabledValue,
        navBackPath: this.navBackPathValue,
        navTitle: this.navTitleValue,
        navActions: this.navActionsValue,
        navbarBackground: this.navbarBackgroundValue,
      },
      (response) => {
        this.handleBranchChange(response)
      },
    )
  }

  handleBranchChange(data) {
    if (!data || !data.spaceGroupKey || !data.spaceBranchKeys) return

    // Build the new URL with selected space/branch
    const branchKeys = Array.isArray(data.spaceBranchKeys)
      ? data.spaceBranchKeys.join(",")
      : data.spaceBranchKeys

    const newPath = `/s:${data.spaceGroupKey}:${branchKeys}${window.location.pathname.replace(/^\/s:[^/]+/, "")}`

    // Navigate to new space URL (Turbo will handle it)
    window.Turbo.visit(newPath)
  }
}
